import { render, staticRenderFns } from "./navigation_article_mng_page.vue?vue&type=template&id=bbb6baf4"
import script from "./navigation_article_mng_page.vue?vue&type=script&lang=js"
export * from "./navigation_article_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbb6baf4')) {
      api.createRecord('bbb6baf4', component.options)
    } else {
      api.reload('bbb6baf4', component.options)
    }
    module.hot.accept("./navigation_article_mng_page.vue?vue&type=template&id=bbb6baf4", function () {
      api.rerender('bbb6baf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/website/navigation_article/navigation_article_mng_page.vue"
export default component.exports